import SearchIcon from './component'

export default SearchIcon
